var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("title",{"key":1},"Pixl"),React.createElement("path",{"className":"cls-1","d":"M11.49,12.76s29,1.74,28.62,30.41V71.84H70.5a28.37,28.37,0,0,1,28.28,28.28v30.73A28.36,28.36,0,0,1,70.5,159.12H39.77a28.36,28.36,0,0,1-28.28-28.27V12.76M1.49,2.14V130.85a38.32,38.32,0,0,0,38.28,38.27H70.5a38.32,38.32,0,0,0,38.28-38.27V100.12A38.32,38.32,0,0,0,70.5,61.84H50.11V43.23c.17-15.36-6.69-27.7-19.3-34.74A47.5,47.5,0,0,0,12.09,2.78L1.49,2.14Z","key":2})]);
}

Logo.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 110.37 170.06"};

module.exports = Logo;

Logo.default = Logo;
